@if (initialized && valueWidgetData) {
    <mvs-widget
            [widgetData]="valueWidgetData"
            (onObjectSelect)="handleValueSelect($event)"
    ></mvs-widget>
} @else if (initialized) {
    <div class="text-center p-4 text-secondary">
        Select a column to view its values
    </div>
}
